let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("eJV9X")).then(() => parcelRequire('79qwo'));